<template>
  <div style="height: 100%; padding: 0 10px">
    <el-card>
      <div slot="header">字典管理</div>
      <div style="height: 100%">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="列表" name="list">
            <el-form
              :inline="true"
              label-width="40px"
              class="searchListInput"
              size="mini"
            >
              <el-form-item label="名称" prop="name">
                <el-input
                  v-model="queryParams.name"
                  placeholder="请输入名称"
                  clearable
                  style="width: 150px"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>

              <el-form-item label="键" prop="dicKey">
                <el-input
                  v-model="queryParams.dicKey"
                  placeholder="请输入键"
                  clearable
                  style="width: 150px"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
              <el-form-item label="值" prop="dicValue">
                <el-input
                  v-model="queryParams.dicValue"
                  placeholder="请输入值"
                  clearable
                  style="width: 150px"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
              <el-form-item class="mb8">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="handleQuery"
                  class="elButtonSearch"
                >
                  搜索
                </el-button>
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
                  >新增
                </el-button>
              </el-form-item>
            </el-form>
            <div class="tableStyle">
              <el-table
                height="93%"
                style="width: fit-content"
                v-loading="loading"
                :data="tableData"
                @row-dblclick="handleTableRow"
              >
                <el-table-column
                  type="index"
                  width="50"
                  label="序号"
                  align="center"
                  :index="indexMethod"
                ></el-table-column>
                <el-table-column
                  label="名称"
                  align="center"
                  prop="name"
                  width="250"
                />
                <el-table-column
                  label="键"
                  align="center"
                  prop="dicKey"
                  width="150"
                />
                <el-table-column
                  label="值"
                  align="center"
                  prop="dicValue"
                  width="150"
                />
                <el-table-column label="操作" align="center" width="200">
                  <template slot-scope="scope">
                    <!-- <el-button -->

                    <el-button
                      size="mini"
                      type="text"
                      icon="el-icon-edit"
                      @click="handleTableRow(scope.row)"
                      >查看详情
                    </el-button>
                    <el-button
                      size="mini"
                      type="text"
                      icon="el-icon-delete"
                      @click="handleDeleteList(scope.row)"
                      disabled
                      >删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block">
                <el-pagination
                  v-show="total > 0"
                  @size-change="handleQuery"
                  @current-change="handleQuery"
                  :current-page.sync="queryParams.current"
                  :page-sizes="[100, 200, 400, 600, 800, 1000]"
                  :page-size.sync="queryParams.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="详情" name="detail">
            <el-form
              :inline="true"
              label-width="68px"
              class="searchListInput"
              size="mini"
            >
              <el-form-item class="mb8">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
                  >新增
                </el-button>
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="handleCopyAdd"
                  >复制新增
                </el-button>
                <el-button
                  type="primary"
                  icon="el-icon-finished"
                  @click="save"
                  class="elButtonSearch"
                >
                  保存
                </el-button>
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  @click="handleDelete"
                  class="elButtonSearch"
                  disabled
                  >删除
                </el-button>
              </el-form-item>
            </el-form>

            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-width="107px"
              style="margin-top: 30px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="名称" prop="name">
                    <el-input
                      v-model="form.name"
                      placeholder="请输入名称"
                      clearable
                      size="small"
                      style="width: 200px"
                      @keyup.enter.native="handleQuery"
                      :disabled="disabled"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="键" prop="dicKey">
                  <el-input
                    v-model="form.dicKey"
                    placeholder="请输入键"
                    clearable
                    size="small"
                    style="width: 200px"
                    @keyup.enter.native="handleQuery"
                    :disabled="disabled"
                  />
                </el-form-item>
              </el-row>
              <el-col :span="8">
                <el-form-item label="值" prop="dicValue">
                  <el-input
                    v-model="form.dicValue"
                    placeholder="请输入值"
                    clearable
                    size="small"
                    style="width: 200px"
                    @keyup.enter.native="handleQuery"
                  />
                </el-form-item>
              </el-col>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import { selectList, add, detail, remove } from '../../api/basic/dictionary';
import { translateObjectEmptyAttributeToNull } from '../../untils/func';
export default {
  // name: "Spring",
  data() {
    return {
      total: 0,
      activeTab: 'list',
      disabled: false,
      // 遮罩层
      loading: true,
      // 字典表格数据
      tableData: [],

      // 查询参数
      queryParams: {
        current: 1,
        size: 100,
        name: '',
        dicKey: '',
        dicValue: '',
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur',
          },
        ],
        dicKey: [
          {
            required: true,
            message: '键不能为空',
            trigger: 'blur',
          },
        ],
        dicValue: [
          {
            required: true,
            message: '值不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      await this.handleQuery();
    },
    async handleQuery() {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectList(param).then();
      this.tableData = response.data;
      this.total = response.total;
      this.loading = false;
    },
    async handleDeleteList(row) {
      await this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then();
      await remove(row.id).then();
      this.msgSuccess('删除成功');
      await this.handleQuery();
    },
    async save() {
      const response = await add(this.form).then();
      const id = response.data;
      this.msgSuccess('保存成功');
      await this.viewDetail(id);
      await this.handleQuery();
    },
    // 修改
    async handleTableRow(row) {
      this.disabled = true;
      this.activeTab = 'detail';
      await this.viewDetail(row.id);
    },

    async viewDetail(id) {
      const response = await detail({
        id: id,
      }).then();
      this.form = response.data;
    },
    // 新增
    async handleAdd() {
      this.disabled = false;
      this.form = {};
      this.activeTab = 'detail';
    },
    // 复制新增
    async handleCopyAdd() {
      this.disabled = false;
      this.form.id = 0;
      this.activeTab = 'detail';
    },

    async handleDelete() {
      if (this.form.id == undefined) {
        return;
      }
      await this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then();
      await remove(this.form.id).then();
      this.msgSuccess('删除成功');
      await this.handleAdd();
      await this.handleQuery();
    },
    indexMethod(index) {
      let num =
        this.queryParams.size * (this.queryParams.current - 1) + index + 1;
      return num;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-form-item {
  display: inline-block;
  margin-bottom: 10px;
}

/deep/ .el-table--scrollable-y .el-table__body-wrapper {
  height: 100% !important;
}

.searchTag {
  width: 200px;
}

.tableStyle {
  height: calc(100vh - 320px);
  // background-color: pink;
}
</style>
